import React, { ReactElement } from 'react';
import WithPage from '../../HOC/Page/WithPage';
import { ISkillbuilderProps as PageTypeSkillBuilder } from '../../models/SkillBuilder/@types';
import MainLayout from '../../layout/MainLayout';
import { getPageData } from '../../models/Contentful';
import { IStaticPageProps } from '../../models/Contentful/types';
import { LayoutPage } from '../../types/page';
import FleischerScholars from '../../components/SkillbuilderList/fleischerScholars';

const FleischerScholarsListPage: LayoutPage<IStaticPageProps<any>> = ({ page }) => {
  return (
    <div>
      <main>
        <FleischerScholars {...(page as PageTypeSkillBuilder)} />
      </main>
    </div>
  );
};

FleischerScholarsListPage.getLayout = function getLayout(
  page: ReactElement,
  props: IStaticPageProps<any>,
) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticProps: any = async ({ params }: any) => {
  const slug = params?.slug || [''];
  const pageResponse = await getPageData<PageTypeSkillBuilder>(slug[0], 'skillbuilder');
  // overwriting the page attribute here, but not the site attribute as
  // it is necessary for the Header component
  const res = { ...pageResponse };
  return { props: res };
};

export default WithPage(FleischerScholarsListPage);
